import React from 'react';
import cn from 'classnames';
import { Button } from '../../../../button/esm';
import { CrossCircleMIcon } from '@alfalab/icons-glyph/CrossCircleMIcon';
import { CrossCircleSIcon } from '@alfalab/icons-glyph/CrossCircleSIcon';

var styles = {"clearIcon":"select__clearIcon_1xe3w","clearButton":"select__clearButton_1xe3w","size-40":"select__size-40_1xe3w"};
require('./index.css');

var ClearButton = function (_a) {
    var disabled = _a.disabled, onClick = _a.onClick, dataTestId = _a.dataTestId, size = _a.size;
    var IconComponent = size === 40 ? CrossCircleSIcon : CrossCircleMIcon;
    return (React.createElement(Button, { type: 'button', view: 'text', disabled: disabled, "aria-label": '\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C', className: cn(styles.clearButton, styles["size-".concat(size)]), onClick: onClick, tabIndex: -1, dataTestId: dataTestId },
        React.createElement(IconComponent, { className: styles.clearIcon })));
};

export { ClearButton };
